import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import Table from 'web-app/react/components/table/model';

import * as Actions from './actions';

const PlanSettingsState = Record({
    fetching: true,
    csvLink: null,
    fundingLoopLink: null,
    tableData: new Table.record(),
    submittingFundingModal: false,
    fundingModalPlanId: null,
    fundingModalFundingTypes: null,
});

export default handleActions(
    {
        [Actions.changeFundingTypeForPlan.type]: state =>
            state.merge({
                submittingFundingModal: true,
            }),
        [Actions.changeFundingTypeForPlanSuccess.type]: state =>
            state.merge({
                fundingModalPlanId: null,
                fundingModalFundingTypes: null,
                submittingFundingModal: false,
            }),
        [Actions.changeFundingTypeForPlanFailed.type]: state =>
            state.merge({
                submittingFundingModal: false,
            }),
        [Actions.showFundingTypeModal.type]: (state, {payload}) =>
            state.merge({
                fundingModalPlanId: payload.planId,
                fundingModalFundingTypes: payload.selectedFundingTypes,
            }),
        [Actions.closeFundingTypeModal.type]: state =>
            state.merge({
                fundingModalPlanId: null,
                fundingModalFundingTypes: null,
            }),
        [Actions.fetchInitialReport.type]: () =>
            new PlanSettingsState({
                fetching: true,
            }),
        [Actions.fetchReport.type]: state =>
            state.merge({
                fetching: true,
            }),
        [Actions.fetchReportFailed.type]: state =>
            state.merge({
                fetching: false,
                csvLink: null,
                fundingLoopLink: null,
                tableData: new Table.record(),
            }),
        [Actions.fetchReportSuccess.type]: (state, {payload}) =>
            state.merge({
                fetching: false,
                csvLink: payload.csvLink,
                fundingLoopLink: payload.fundingLoopLink,
                tableData: payload.table,
            }),
        [Actions.reset.type]: () => new PlanSettingsState(),
    },
    new PlanSettingsState(),
);
